<template>
  <div class="form_layout">
    <div class="form_outer">
      <div class="dialog_form_head" v-if="this.rediskey===null">
        企业走访情况
      </div>

      <div class="dialog_form">
        <el-form :model="addData" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="dialog_head">
          <span class="tit">企业走访情况反馈表</span>
          <el-date-picker
            readonly
            v-model="addData.year"
            value-format="yyyy"
            type="year"
            placeholder="选择年"
            style="width:150px;">
          </el-date-picker>
          &nbsp;
          &nbsp;
          <el-select disabled v-model="addData.quarter" placeholder="请选择" @change="handleJDChange()" style="width:150px;">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table">
            <tr>
              <td class="td_bg" width="100px">走访人</td>
              <td colspan="3">
                <el-input v-model="addData.zf_name"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="border-left: 0;border-right: 0;">
                <div>主要经济指标预测：</div>
              </td>
            </tr>
            <tr>
              <td class="td_bg"></td>
              <td class="td_bg">产值（万元）</td>
              <td class="td_bg">税收（万元）</td>
              <td class="td_bg">500万元以上固定资产（万元）</td>
            </tr>

            <tr>
              <td class="td_bg">{{ addData.quarter }}季度</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.jd_yc_pro"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.jd_yc_tax"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.jd_yc_500gdzc"></el-input>
              </td>
            </tr>
            <tr v-if="addData.quarter<3">
              <td class="td_bg">上半年</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.byear_yc_pro"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.byear_yc_tax"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.byear_yc_500gdzc"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">全年</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.qyear_yc_pro"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.qyear_yc_tax"></el-input>
              </td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.qyear_yc_500gdzc"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="border-left: 0;border-right: 0;">企业经营情况：</td>
            </tr>
            <tr>
              <td colspan="4">
                <el-form-item  prop="jyqk">
                <el-input type="textarea" :rows="3" v-model="addData.jyqk"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>

              <td colspan="4" style="border-left: 0;border-right: 0;">科技创新、改制、上市、投资、改扩建、技改、融资需求等情况：</td>
            </tr>
            <tr>
              <td colspan="4">
                <el-form-item  prop="fzxq">
                <el-input type="textarea" :rows="3" v-model="addData.fzxq"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="border-left: 0;border-right: 0;">受疫情影响、企业存在的困难或需解决的问题共享员工、共享空间、共享平台：</td>
            </tr>
            <tr>
              <td colspan="4">
                <el-form-item  prop="knywt">
                <el-input type="textarea" :rows="3" v-model="addData.knywt"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </div>

      </el-form>
        <div class="footer_btn">
          <el-button type="primary" :disabled="btn_disabled1" @click="onSubmitAdd(2,'ruleForm')">提 交</el-button>
          <el-button :disabled="btn_disabled1" @click="onSubmitAdd(1,'ruleForm')">暂 存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    let redisKey= this.$route.query.rediskey;
    if(redisKey!==undefined && redisKey!==null){
      window.localStorage.setItem("gyzhqy_token",redisKey);
      this.addData.corpid=this.$route.query.corpid;
      this.rediskey=redisKey;
    }
    let id = this.$route.query.corpId;
    if (id !== undefined) { // 管理端调用
      this.addData.corpId=id;
    }
    this.canAdd();
  },
  name: 'addvisit',
  data() {
    return {
      btn_disabled1: false,
      btn_disabled2: false,
      rediskey:null,
      addData: {
        byear_yc_pro: null,
        byear_yc_tax: null,
        byear_yc_500gdzc: null,
        zf_name: null,
        tbr: null,
        year: null,
        tel: null,
        quarter: null,
        qyear_yc_pro: null,
        qyear_yc_tax: null,
        qyear_yc_500gdzc: null,
        jd_yc_tax: null,
        jd_yc_pro: null,
        jd_yc_500gdzc: null,
        jyqk: null,
        knywt: null,
        fzxq: null,
        opt_state: null
      },
      value2: '',
      options: [{
        value: 1,
        label: '1季度'
      }, {
        value: 2,
        label: '2季度'
      }, {
        value: 3,
        label: '3季度'
      }, {
        value: 4,
        label: '4季度'
      }],
      rules: {
        jyqk: [
          { min: 0, max: 600, message: '企业经营情况不能超过600字', trigger: 'blur' }
        ],
        fzxq: [
          { min: 0, max: 600, message: '企业需求等情况不能超过600字', trigger: 'blur' }
        ],
        knywt: [
          { min: 0, max: 600, message: '企业存在的困难或需解决的问题不能超过600字', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    async canAdd() {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/interview/getId');
      if (res.data.data.year !== null && res.data.data.quarter !== null) {
        this.addData.year = res.data.data.year+'';
        this.addData.quarter = res.data.data.quarter;
      } else {
        this.$message.error(res.data.msg);
        this.btn_disabled1 = true;
        this.btn_disabled2 = true;
      }

    },

    async onSubmitAdd(status,formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAdd(status);
        } else {
          setTimeout(()=>{
            var isError = document.getElementsByClassName("is-error");
            console.log(isError)
            var htmlInputElement = isError[0].querySelector('input');
            if(htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if(htmlAreaElement) htmlAreaElement.focus();
          },100);
          // alert('error submit!!');
          return false;
        }
      });

    },

    async submitAdd(opt_state) {
      let data = this.addData;
      data.opt_state = opt_state;
      this.btn_disabled1 = true;
      this.btn_disabled2 = true;
      let res = await this.$ajax.post(this.bUrl + 'api/portal/interview/save', data);
      if (res.data.code !== 200) {
        this.$message.error(res.data.msg);
      }else{
        this.$message.success(res.data.msg);
      }

      if (opt_state === 2) {
        this.$emit('emitClose')
      }
      this.btn_disabled1 = false;
      this.btn_disabled2 = false;
    },
    handleJDChange() {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/form/addvisit.vue